export const createMobileSlice = (set, get) => ({
  reports: [],
  setReports: value => set(() => ({ reports: value })),
  questionnaires: [],
  setQuestionnaires: value => set(() => ({ questionnaires: value }))
});
